import { useMemo } from 'react'

import { useGetOrgDatabases } from '@/resolvers/db/query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useIsProjectDb } from '@/hooks/useIsProjectDb'
import { ORG_DATABASE_ROUTE, ORG_ROUTE } from '@/shared/constants'
import { DbDropdown } from '@/components/DbDropdown'

export const LayoutDatabaseDropdown = () => {
  const { data: databases } = useGetOrgDatabases()

  const { db } = useDbClientContext()
  const { currentOrg } = useCurrentOrgContext()
  const isProject = useIsProjectDb()

  const dbOptions = useMemo(() => {
    return (databases || []).sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  }, [databases])

  return isProject ? (
    <div className='text-light'>{db?.name}</div>
  ) : (
    <DbDropdown
      value={db}
      menuDefaultSize={false}
      menuContainerClassName='min-w-[200px]'
      menuClassName='max-h-[260px] overflow-y-auto'
      onChange={(opt) => {
        if (opt.id === db?.id || !currentOrg) return
        window.location.href = `${ORG_ROUTE}/${currentOrg.id}/${ORG_DATABASE_ROUTE}/${opt.id}`
      }}
      options={dbOptions}
    />
  )
}
